import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { CSSTransition } from "react-transition-group"
import { connect } from 'react-redux'
import { editEndpointList } from '../actions/endpoints'
import { Formik } from 'formik'
import Statuspick from './statuspick'
import FormButtonPanel from './utilities/FormButtonPanel'
import _ from 'lodash'

class ACLForm extends Component {
    constructor(props) {
        super(props)

        this.handleSubmit = this.handleSubmit.bind(this)

        this.state = {
            endpoints: props.endpoints,
            isFetching: props.isFetching,
            ACLEndpointList: []
        }

        console.log("went here")
    }

    breadCrumb() {
        let breadCrumb = window.location.href.split('/')
        return breadCrumb
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            endpoints: nextProps.endpoints,
            ACLEndpointList: nextProps.ACLEndpointList,
            isFetching: nextProps.isFetching
        })
    }

    handleSubmit(values) {
        let { dispatch, accessToken } = this.props

        let promiseArray = []
        let backendACL = this.props.ACLEndpointList.filter(acl => acl.id !== undefined)
        let frontendACL = []
        // Process values back to individual ACL rows
        values.endpoints.forEach(endPt => {
            let modelName = endPt.modelName
            endPt.ACLRules.forEach(aclRule => {
                let ACLRead = backendACL.find(acl => (acl.model === modelName && acl.principalId === aclRule.role && acl.accessType === 'READ'))
                if (!ACLRead) {
                    let defaultRule = {
                        model: modelName,
                        property: "*",
                        accessType: "READ",
                        permission: aclRule.role === 'admin' ? "ALLOW" : "DENY",
                        principalType: "ROLE",
                        principalId: aclRule.role
                    }
                    frontendACL.push(defaultRule)
                } else {
                    frontendACL.push({
                        ...ACLRead,
                        permission: aclRule.view ? 'ALLOW' : 'DENY'
                    })
                }

                let ACLWrite = backendACL.find(acl => (acl.model === modelName && acl.principalId === aclRule.role && acl.accessType === 'WRITE'))
                if (!ACLWrite) {
                    let defaultRule = {
                        model: modelName,
                        property: "*",
                        accessType: "WRITE",
                        permission: aclRule.role === 'admin' ? "ALLOW" : "DENY",
                        "principalType": "ROLE",
                        "principalId": aclRule.role
                    }
                    frontendACL.push(defaultRule)
                } else {
                    frontendACL.push({
                        ...ACLWrite,
                        permission: aclRule.edit ? 'ALLOW' : 'DENY'
                    })
                }
            })
        })

        // Get only ACL rules that have changed
        let changedRules = _.differenceWith(frontendACL, backendACL, _.isEqual)

        // Get new ACL rules not yet in backend
        let newRules = frontendACL.filter(acl => acl.id === undefined)

        changedRules.forEach(aclRule => {
            promiseArray.push(dispatch(
                editEndpointList(9, 'acls', accessToken, aclRule)
            ))
        })

        newRules.forEach(aclRule => {
            promiseArray.push(dispatch(
                editEndpointList(9, 'acls', accessToken, aclRule)
            ))
        })
    }

    render() {
        let {
            endpoints,
            isFetching
        } = this.state

        // Initialize an empty object
        let objProp = {}

        // Initial values
        let initVal = Object.assign({}, { endpoints }, objProp)

        return (
            <div className="">
                <div className="component-title list-group" id="working-area">
                    <div className="list-group-item list-group-item-action gradient-background">
                        <div className="" id="endpoint-label-wrapper">
                            <div className="float-left breadcrumbs">
                                <div className="">
                                    <p>
                                        <Link to={'/'}><i className="fas fa-th"></i></Link>
                                        <i className="fas fa-arrow-right"></i>
                                        <Link to={`/${this.breadCrumb()[3]}`}>
                                            ACLs
                                        </Link>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <CSSTransition
                        in={true}
                        appear={true}
                        timeout={500}
                        classNames="fade"
                    >
                        {   // do not render if ACLs are still fetching
                            this.props.initialized ? (
                                <div id="working-area-content" className="">
                                    <div className="form-area-wrapper">

                                        <Formik
                                            initialValues={initVal}
                                            enableReinitialize
                                            onSubmit={this.handleSubmit}
                                            render={({
                                                handleSubmit,
                                                handleChange,
                                                values
                                            }) => {
                                                return (
                                                    <form className="form-area-form " onSubmit={handleSubmit}>
                                                        <div key="btn-panel-top" className="add-field-wrapper">
                                                            <div className="absolute-btn">
                                                                <FormButtonPanel
                                                                    endpointName='acls'
                                                                    isFetching={isFetching}
                                                                    formType='new'
                                                                    parentUrl='/'
                                                                    allowDelete={false}
                                                                    onDelete={() => { }} />
                                                            </div>
                                                        </div>
                                                        <div className="accordion" id="endpoint-accordion">
                                                            {
                                                                values.endpoints.map((endpoint, index) => (
                                                                    <div className="card" key={`acl-card-${index}`}>
                                                                        <div className="card-header" id={`enpoint-header-${index}`}>
                                                                            <button className="btn btn-link" type="button" data-toggle="collapse" data-target={`#enpoint-collapse-${index}`} aria-expanded="false" aria-controls={`enpoint-collapse-${index}`}>
                                                                                {endpoint.name}
                                                                            </button>
                                                                        </div>
                                                                        <div className="collapse" id={`enpoint-collapse-${index}`} aria-labelledby={`enpoint-header-${index}`} data-parent="#endpoint-accordion">
                                                                            <div className="card-body">
                                                                                <div className="container">
                                                                                    <div className="row endpoint-acl-heading">
                                                                                        <div className="col-2">
                                                                                            <h5>Role</h5>
                                                                                        </div>
                                                                                        <div className="col-2">
                                                                                            <h5>View</h5>
                                                                                        </div>
                                                                                        <div className="col-2">
                                                                                            <h5>Edit</h5>
                                                                                        </div>
                                                                                    </div>
                                                                                    {
                                                                                        endpoint.ACLRules.map((aclRule, aclIndex) => (
                                                                                            <div className="row" key={`endpoint${index}-rule${aclIndex}`}>
                                                                                                <div className="col-2">
                                                                                                    {aclRule.role}
                                                                                                </div>
                                                                                                <div className="col-2">
                                                                                                    <Statuspick
                                                                                                        id={`endpoint${index}-rule${aclIndex}-view`}
                                                                                                        className="form-control"
                                                                                                        name={`endpoints[${index}].ACLRules[${aclIndex}].view`}
                                                                                                        onChange={handleChange}
                                                                                                        defaultChecked={aclRule.view}
                                                                                                        status={aclRule.view ? 1 : 0} />
                                                                                                </div>
                                                                                                <div className="col-2">
                                                                                                    <Statuspick
                                                                                                        id={`endpoint${index}-rule${aclIndex}-edit`}
                                                                                                        className="form-control"
                                                                                                        name={`endpoints[${index}].ACLRules[${aclIndex}].edit`}
                                                                                                        onChange={handleChange}
                                                                                                        defaultChecked={aclRule.edit}
                                                                                                        status={aclRule.edit ? 1 : 0} />
                                                                                                </div>
                                                                                            </div>
                                                                                        ))
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))
                                                            }
                                                        </div>
                                                    </form>
                                                )
                                            }} />
                                    </div>
                                </div>
                            ) : <div></div> // do not render if ACLs are still fetching
                        }
                    </CSSTransition>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    let ACLEndpoint = state.endpoints.find(endPt => endPt.name === 'acls')
    let RoleEndpoint = state.endpoints.find(endPt => endPt.name === 'roles')
    // Get ACL endpoint list
    let ACLEndpointList = ACLEndpoint.list.map(acl => ({ ...acl }))
    let isFetching = ACLEndpoint.isFetching

    let initialized = ACLEndpoint.initialized && RoleEndpoint.initialized

    //Make copy of roles, add harcoded roles to it
    let roles = RoleEndpoint.list.map(role => role.name)
    let harcodeRoles = [
        '$authenticated',
        '$everyone'
    ]
    roles.push(...harcodeRoles)

    // Make a copy of endpoints
    let endpoints = state.endpoints.map(endPt => {
        // Create a new object to return
        let endPtACL = {}

        endPtACL.name = endPt.name
        endPtACL.modelName = endPt.modelName

        endPtACL.ACLRules = roles.map(role => {
            // If the role ACL does not yet exist creat it
            let aclRule = {
                role: role,
                view: false,
                edit: false
            }

            let ACLRead = ACLEndpointList.find(acl => (acl.model === endPtACL.modelName && acl.principalId === role && (acl.accessType === 'READ' || acl.accessType === '*')))
            if (!ACLRead) {
                let defaultRule = {
                    model: endPtACL.modelName,
                    property: "*",
                    accessType: "READ",
                    permission: role === 'admin' ? "ALLOW" : "DENY",
                    principalType: "ROLE",
                    principalId: role
                }
                ACLEndpointList.push(defaultRule)
                aclRule.view = defaultRule.permission === 'ALLOW'
            } else {
                aclRule.view = ACLRead.permission === 'ALLOW'
            }

            let ACLWrite = ACLEndpointList.find(acl => (acl.model === endPtACL.modelName && acl.principalId === role && (acl.accessType === 'WRITE' || acl.accessType === '*')))
            if (!ACLWrite) {
                let defaultRule = {
                    model: endPtACL.modelName,
                    property: "*",
                    accessType: "WRITE",
                    permission: role === 'admin' ? "ALLOW" : "DENY",
                    "principalType": "ROLE",
                    "principalId": role
                }
                ACLEndpointList.push(defaultRule)
                aclRule.edit = defaultRule.permission === 'ALLOW'
            } else {
                aclRule.edit = ACLWrite.permission === 'ALLOW'
            }

            return aclRule
        })

        return endPtACL
    })

    return {
        endpoints,
        ACLEndpointList,
        isFetching,
        initialized,
        accessToken: state.auth.access_token
    }
}

export default connect(mapStateToProps)(ACLForm)


// WEBPACK FOOTER //
// ./src/components/aclForm.js